import Vue from 'vue';
import VueInitilizers from 'vue-initializers';

Vue.use(VueInitilizers, {
  requires: require.context('@/initializers', false, /\w+\.js$/),
});

import App from '@/App';
import router from '@/router';
import store from '@/store';
import './registerServiceWorker';

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
